export default "__VITE_ASSET__ChUbST$u__"